import { pdf } from "@react-pdf/renderer"
import { PdfTemplate } from "components"
import moment from "moment"
import { APPROVAL } from "pages/Sales/Register/utils/vars"
import { DetailCustomerQuotation } from "pages/Sales/Transaction/CustomerQuotation/types"
import { calculateSummaryCQ } from "pages/Sales/Transaction/CustomerQuotation/utils/functions"
import { cellValuePdf, RowExportTypePdf } from "types"
import { convertNumber } from "utils"
import { mapCustomerQuotationDetail } from "../functions"

type UseExportPdfQuotation = {
  data: DetailCustomerQuotation[]
  dateFilter: string
}

export const useExportPdfQuotation = ({
  data,
  dateFilter
}: UseExportPdfQuotation) => {

  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "QUOTATION ID#", key: "quotation_id", width: 25 },
    { header: "REF SO ID#", key: "ref_so_id", width: 25 },
    { header: "DATE", key: "date", width: 15 },
    { header: "SALES", key: "sales", width: 15 },
    { header: "CUSTOMER", key: "customer", width: 15 },
    { header: "LOCATION", key: "location", width: 15 },
    { header: "STATUS", key: "status", width: 15 },
    { header: "QTY. ORDER", key: "qty_order", width: 15 },
    { header: "TOTAL SALES", key: "total_sales", width: 15 },
  ]

  function numberFormat(value: number): cellValuePdf {
    return {
      text: convertNumber(value).intoCurrency,
      style: {
        textAlign: "right",
        fontWeight: "bold"
      }
    }
  }

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    const sumQtyOrder = item.detail.reduce((total, item) => total + item.qty_order, 0);
    const mapDetail = mapCustomerQuotationDetail(item.detail)
    const summary = calculateSummaryCQ({
      detail: mapDetail,
      freight: item.freight
    })

    return {
      no: (index + 1).toString(),
      quotation_id: item.trx_code,
      ref_so_id: "-",
      date: moment(item.transaction_date).format("DD/MM/YYYY"),
      sales: item.employee.employee_name,
      customer: item.customer.customer_name,
      location: item.location.location_name,
      status: APPROVAL[item.approve_status],
      qty_order: numberFormat(sumQtyOrder),
      total_sales: numberFormat(summary.totalAmount)
    }
  })

  return {
    handleExportPdf: () =>
      pdf(
        <PdfTemplate
          module="SALES"
          title="QUOTATION"
          data={dataMap}
          column={columns}
          date={dateFilter}
        />
      )
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = `quotation-${dateFilter}.pdf`
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        })
  }
}


